import { header } from '@Styles/colors';
import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		padding: 16,
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: '1px solid #e2e8f0',
	},
	tabViewItem: {
		borderBottom: `1px solid #D3DBDE `,
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: 44,
		padding: '0 36px',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		alignItems: 'center',
	},
	section: {
		padding: 16,
	},
	header: {
		display: 'flex',
		gap: 16,
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginBottom: 16,
		width: '100%',
	},
	noResults: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 16,
	},
	tableContainer: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '80%',
	},
	loadingRow: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	},
	tableOverrides: {
		width: '100%',
		tableLayout: 'fixed',
	},
	statusIndicator: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				height: 20,
				margin: '0 10px 0 -30px',
				width: 20,
			},
			'span'
		),
	},
	statusIndicatorActive: {
		marginRight: 10,
	},
	statusIndicatorInactive: {
		opacity: 0.5,
	},
	etlStagesContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		padding: 20,
	},
	confirmationDialogDescription: {
		fontSize: 14,
		color: '#333',
		marginBottom: spacing.sm,
		textAlign: 'center',
		maxWidth: 600,
	},
	icons: {
		height: 17,
		width: 17,
		marginLeft: spacing.sm,
		display: 'inline-block',
		verticalAlign: 'middle',
	},
	copyButton: {
		alignItems: 'center',
		display: 'flex',
		gap: 5,
	},
});
